/**************************************************
 * Nombre:       Seccion_Funnels
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_IMG,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch, OndemandVideo, PreviewOutlined} from "@mui/icons-material";
import {ESTADOSPRENDA} from "../../Constantes";
import {irFunnel} from "../../CodNegocio/Funnels/irFunnel";
import Dialogo_Funnel_Dos from "../Dialogos/Funnels/Dialogo_Funnel_Dos";
import Dialogo_Funnel_Videos from "../Dialogos/Funnels/Dialogo_Funnel_Videos";

const Seccion_Funnels = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'funnels'})
    const {Dialogo: Dialogo, abrir: abrir} = useDialogo({
        Componente: Dialogo_Funnel_Dos,
        titulo: 'Detalles Funnel',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVideos, abrir: abrirVideos} = useDialogo({
        Componente: Dialogo_Funnel_Videos,
        titulo: 'Detalles Funnel',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'videos':
                abrirVideos(data)
                break
            case 'ver':
                irFunnel({entidad: data})
                break
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoVideos/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Funnels`}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        textoAgregar={'Agregar Funnel'}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Funnels

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '',
        direccion: 'left',
        propiedad: 'img',
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Fecha',
        direccion: 'left',
        propiedades: ['nombre',],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Descripcion',
        direccion: 'left',
        propiedad: 'descripcion',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPRENDA
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Videos',
        id: 'videos',
        icono: OndemandVideo
    },
    {
        nombre: 'Ver',
        id: 'ver',
        icono: PreviewOutlined
    },
]